import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import isEmpty from 'lodash/isEmpty';
import { Filter } from 'components/molecules/filters/types';
import { DynamicTemplateConditions, ProjectTemplateStore } from '../types';

export const dynamicTemplateSlice = {
  setDynamicConditions: (
    state: ProjectTemplateStore,
    { payload }: PayloadAction<DynamicTemplateConditions>,
  ): ProjectTemplateStore => {
    const path = `data.${state.activeId}.dynamicConditions`;

    return dotPropImmutable.set(state, path, payload);
  },

  updateDynamicConditions: (
    state: ProjectTemplateStore,
    {
      payload: { entityId, conditions },
    }: PayloadAction<{ entityId: number; conditions: Filter }>,
  ): ProjectTemplateStore => {
    const path = `data.${state.activeId}.dynamicConditions.${entityId}`;

    if (isEmpty(conditions.criteria)) {
      return {
        ...state,
        ...dotPropImmutable.delete(state, path),
      };
    }

    return dotPropImmutable.set(state, path, conditions);
  },
};
